<template>
  <div class="box-list-alert">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.box-list-alert {
  font-size: 1rem;
  line-height: 1.6;
  padding: 8px;
  box-sizing: border-box;
  text-align: left;
  max-width: 100%;
  border-radius: 4px;
  color: $danger;
  background-color: #faeae9;
  border: 1px solid rgba($danger, 0.3);
}
</style>
